var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerWorkletStackDetails = registerWorkletStackDetails;
exports.reportFatalErrorOnJS = reportFatalErrorOnJS;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _workletStackDetails = new Map();
function registerWorkletStackDetails(hash, stackDetails) {
    _workletStackDetails.set(hash, stackDetails);
}
function getBundleOffset(error) {
    var _error$stack, _error$stack$split;
    var frame = (_error$stack = error.stack) == null ? void 0 : (_error$stack$split = _error$stack.split("\n")) == null ? void 0 : _error$stack$split[0];
    if (frame) {
        var parsedFrame = /@([^@]+):(\d+):(\d+)/.exec(frame);
        if (parsedFrame) {
            var _parsedFrame = (0, _slicedToArray2.default)(parsedFrame, 4), file = _parsedFrame[1], line = _parsedFrame[2], col = _parsedFrame[3];
            return [
                file,
                Number(line),
                Number(col)
            ];
        }
    }
    return [
        "unknown",
        0,
        0
    ];
}
function processStack(stack) {
    var workletStackEntries = stack.match(/worklet_(\d+):(\d+):(\d+)/g);
    var result = stack;
    workletStackEntries == null ? void 0 : workletStackEntries.forEach(function(match) {
        var _match$split$map = match.split(/:|_/).map(Number), _match$split$map2 = (0, _slicedToArray2.default)(_match$split$map, 4), hash = _match$split$map2[1], origLine = _match$split$map2[2], origCol = _match$split$map2[3];
        var errorDetails = _workletStackDetails.get(hash);
        if (!errorDetails) {
            return;
        }
        var _errorDetails = (0, _slicedToArray2.default)(errorDetails, 3), error = _errorDetails[0], lineOffset = _errorDetails[1], colOffset = _errorDetails[2];
        var _getBundleOffset = getBundleOffset(error), _getBundleOffset2 = (0, _slicedToArray2.default)(_getBundleOffset, 3), bundleFile = _getBundleOffset2[0], bundleLine = _getBundleOffset2[1], bundleCol = _getBundleOffset2[2];
        var line = origLine + bundleLine + lineOffset;
        var col = origCol + bundleCol + colOffset;
        result = result.replace(match, "".concat(bundleFile, ":").concat(line, ":").concat(col));
    });
    return result;
}
function reportFatalErrorOnJS(_ref) {
    var message = _ref.message, stack = _ref.stack;
    var error = new Error();
    error.message = message;
    error.stack = stack ? processStack(stack) : undefined;
    error.name = "ReanimatedError";
    error.jsEngine = "reanimated";
    global.ErrorUtils.reportFatalError(error);
}
